import { Component, inject, WritableSignal } from '@angular/core';
import { NotificationsService } from '../../services/notifications-service';
import { NotificationItemType, NotificationType } from '../../models/notifications-type.model';
import { DisplayAnimations } from '../../directives/display-animations';
import { LottieComponent } from 'ngx-lottie';
import { IconType, Icon } from '../icon/icon';

@Component({
  selector: 'app-notification-block',
  template: `
    @let notification = notifications()[0];
    @if (notification) {
      <section appDisplayAnimations>
        @if (notification.animationOptions) {
          <ng-lottie [options]="notification.animationOptions" />
        } @else {
          <app-icon class="icon" [icon]="getIcon(notification.type)" [size]="3" />
          <p class="title">{{ notification.title }}</p>
          @if(notification.msg){
            <p class="message">
              {{ notification.msg }}
            </p>
          }
        }
      </section>
    }
  `,
  styleUrl: './notification-block.scss',
  imports: [DisplayAnimations, LottieComponent, Icon],
})
export class NotificationBlock {
  private readonly notificationsService: NotificationsService = inject(NotificationsService);
  protected notifications: WritableSignal<NotificationType[]> =
    this.notificationsService.notifications;

  getIcon(type: NotificationItemType): IconType {

    switch (type) {
      case 'upcomingResistance':
        return 'force'
      case 'upcomingIncline':
        return 'mountain';
      case 'buffering':
        return 'load'
      case 'finish':
        return 'complete_flag';

      default:
        return type as IconType;
    }

  }
}
